import ru from 'vuetify/src/locale/ru.ts'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import dzen from '@/components/Dzen'

Vue.use(Vuetify)
const opts = {
  theme: {
    themes: {
      light: {
        primary: '#1E4158',
        secondary: '#3F68B1',
        accent: '#3F68B1',
        green: '#7DAA55',
        error: '#d73e2b',
      },
      dark: {
        primary: '#1E4158',
        secondary: '#3F68B1',
        accent: '#3F68B1',
        green: '#7DAA55',
        error: '#d73e2b',
      },
    },
  },
  lang: {
    locales: { ru },
    current: 'ru',
  },
  icons: {
    values: {
      Дзен: {
        component: dzen,
      },
      Вконтакте: 'mdi-vk',
      YouTube: 'mdi-youtube',
      Telegram: 'mdi-telegram',
      Одноклассники: 'mdi-odnoklassniki',
    },
  },
}

export default new Vuetify(opts)
